<template>
  <svg
    width="120"
    height="120"
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.4113 63.9956C37.4574 63.9956 47.2227 54.2303 47.2227 42.1842C47.2227 30.1381 37.4574 20.3728 25.4113 20.3728C13.3652 20.3728 3.59998 30.1381 3.59998 42.1842C3.59998 54.2303 13.3652 63.9956 25.4113 63.9956Z"
      :fill="cssVars.colorSurface400"
      :stroke="cssVars.colorGray6"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M107.428 25.6683C107.944 26.7002 107.576 27.9532 106.544 28.4691L101.605 30.9751C100.574 31.4911 99.3206 31.1225 98.8047 30.0907C98.2887 29.0588 98.6572 27.8058 99.6891 27.2898L104.627 24.7838C105.659 24.2679 106.912 24.7101 107.428 25.6683Z"
      :fill="cssVars.colorSurface400"
      :stroke="cssVars.colorGray4"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M97.0355 16.9709L93.7925 22.8674"
      :stroke="cssVars.colorGray4"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      opacity="0.6"
      d="M55.455 45.9109H109.02C113.102 45.9109 116.41 49.579 116.41 54.1034V85.6907C116.41 90.1799 112.731 93.8192 108.194 93.8192H102.186L102.527 102.941L88.378 93.8192H55.455C51.3737 93.8192 48.0651 90.1511 48.0651 85.6261V54.1029C48.0651 49.579 51.3737 45.9109 55.455 45.9109Z"
      :fill="cssVars.colorLine100"
    />
    <path
      d="M84.2809 45.9109H105.512L95.7585 77.2096L84.2809 45.9109Z"
      :fill="cssVars.colorGray4"
    />
    <path
      d="M87.012 34.4207H25.0452C20.4538 34.4207 16.7321 38.1424 16.7321 42.7338V75.8005C16.7321 80.3919 20.4538 84.1137 25.0452 84.1137H30.1617L30.6556 98.1405L45.1422 84.1137H87.012C91.6033 84.1137 95.3251 80.3919 95.3251 75.8005V42.7338C95.3251 38.1424 91.6033 34.4207 87.012 34.4207Z"
      :fill="cssVars.colorSurface400"
      :stroke="cssVars.colorGray6"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M61.3131 89.4331H91.8721L104.684 97.9534V89.4331H109.603"
      :stroke="cssVars.colorGray6"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M85.5462 46.6652L44.2679 46.9995L44.3013 51.1212L85.5796 50.7868L85.5462 46.6652Z"
      :fill="cssVars.colorGray4"
    />
    <path
      d="M85.6235 56.2814L44.3452 56.6157L44.3786 60.7374L85.6569 60.403L85.6235 56.2814Z"
      :fill="cssVars.colorGray4"
    />
    <path
      d="M68.5848 66.036L44.4232 66.2317L44.4565 70.3534L68.6182 70.1576L68.5848 66.036Z"
      :fill="cssVars.colorGray4"
    />
    <path
      d="M25.4112 58.1828C34.2488 58.1828 41.4132 51.0185 41.4132 42.1809C41.4132 33.3433 34.2488 26.179 25.4112 26.179C16.5736 26.179 9.4093 33.3433 9.4093 42.1809C9.4093 51.0185 16.5736 58.1828 25.4112 58.1828Z"
      :fill="cssVars.colorGray4"
    />
    <path
      d="M16.5325 43.7444L18.3086 37.5842C19.5411 33.3096 24.0465 30.8203 28.3211 32.0528C32.5957 33.2854 35.0849 37.7907 33.8524 42.0653L32.0763 48.2256"
      :fill="cssVars.colorSurface400"
    />
    <path
      d="M16.5325 43.7444L18.3086 37.5842C19.5411 33.3096 24.0465 30.8203 28.3211 32.0528C32.5957 33.2854 35.0849 37.7907 33.8524 42.0653L32.0763 48.2256"
      :stroke="cssVars.colorSurface400"
      stroke-width="1.14585"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M13.9119 44.3196C13.9119 44.3196 25.4396 43.2048 33.9904 50.1077Z"
      :fill="cssVars.colorSurface400"
    />
    <path
      d="M13.9119 44.3196C13.9119 44.3196 25.4396 43.2048 33.9904 50.1077"
      :stroke="cssVars.colorSurface400"
      stroke-width="1.14585"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M27.2924 49.6699C26.9254 50.9428 24.8574 51.8274 22.7922 51.2319C20.7271 50.6364 19.4472 48.7871 19.8142 47.5142"
      :fill="cssVars.colorSurface400"
    />
    <path
      d="M27.2924 49.6699C26.9254 50.9428 24.8574 51.8274 22.7922 51.2319C20.7271 50.6364 19.4472 48.7871 19.8142 47.5142"
      :stroke="cssVars.colorSurface400"
      stroke-width="1.14585"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useNamespace } from '@jdesign-vue/hooks'

let id = 0
export default defineComponent({
  name: 'NewsEmpty',
  setup() {
    const ns = useNamespace('empty')

    const cssVars = {
      colorLine100: `var(${ns.cssVarName('color-line-100')})`,
      colorGray4: `var(${ns.cssVarName('color-gray-4')})`,
      colorGray6: `var(${ns.cssVarName('color-gray-6')})`,
      colorSurface400: `var(${ns.cssVarName('color-surface-400')})`,
    }

    return {
      ns,
      id: ++id,
      cssVars,
    }
  },
})
</script>
